import type { AppState } from '../types';

export const DEFAULT_APP_STATE: AppState = {
	data: {},
	categoryIndex: null,
	programmeIndex: null,
	lang: 'hu'
};
